import React from 'react';
import Slider from "../UserPages/slider";
import News from "../Pages/News";
import Activity from "../UserPages/Activities";
import Photo from "../UserPages/Photo";
import "./Home.css";

function Home() {
    return (
        <>
            <div className='slider-home'>
                <Slider />
            </div>
            <div className='news-home'>
                <News />
            </div>
            <Activity/>
            <Photo />
        </>
    );
}

export default Home;